import { Button } from "primereact/button";
import React from "react";
import { useSelector } from "react-redux";
import { handlePutRequest } from "../../../services/PutTemplate";

const EnableorDisableCompProducts = ({ handleCancel, getCompanyProductDetail }) => {

    const editFlag__Store = useSelector((state) => state.companySlice?.companyProductEditFlag);
    const companyProductId = useSelector((state) => state.companySlice?.companyProductFormData?.companyProductId);
    const isDisable = useSelector((state) => state.companySlice?.companyProductFormData?.isActive);

    const enableorDisableCompProducts = async (e) => {
        const data = {
            companyProductId,
            isActive: isDisable === "N" ? "Y" : "N",
        };
        try {
            await handlePutRequest(data, "zbizgateway/nonFin/enableDisableCompanyProduct");
            getCompanyProductDetail();
            handleCancel(e);
        } catch (error) {
            console.log(error);
        }
    };

    if (!editFlag__Store) {
        return null;
    }

    if (isDisable === "N") {
        return <Button type="button" label="Enable" className="Btn__Transparent" style={{ marginRight: "10px" }} onClick={enableorDisableCompProducts} />;
    }

    return <Button type="button" label="Disable" className="Btn__Transparent" style={{ marginRight: "10px" }} onClick={enableorDisableCompProducts} />;
}

export default EnableorDisableCompProducts